import { ref } from 'vue'

export default (context, inject) => {
  const showModal = ref(false)
  const modalImg = ref(null)

  const openModal = (data) => {
    showModal.value = true
    modalImg.value = data
  }

  const closeModal = () => {
    showModal.value = false
    modalImg.value = null
  }

  inject('showModal', showModal)
  inject('modalImg', modalImg)
  inject('openModal', openModal)
  inject('closeModal', closeModal)
}
